// 207 -- centralised registry of app-owned localStorage keys plus a single
// purge invoked on logout. Sensitive client-side state (impersonation-persona
// bookmarks holding other users' emails/names, and list-grid preferences that
// can echo a searched pupil's name) must never survive sign-out on a shared or
// kiosk machine. Store-IDs-not-PII where possible; purge the rest here.

export const PERSONA_STORAGE_KEY = "persona-switcher";
export const GRID_PREFS_PREFIX = "grid-prefs:";

/** Remove all app-owned localStorage entries that may contain PII. */
export function purgeSensitiveClientState(): void {
  try {
    localStorage.removeItem(PERSONA_STORAGE_KEY);
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(GRID_PREFS_PREFIX)) toRemove.push(k);
    }
    for (const k of toRemove) localStorage.removeItem(k);
  } catch {
    /* localStorage unavailable -- nothing to purge */
  }
}
